import { observer, Provider } from 'mobx-react'
import './App.scss'
import Header from './components/Header/Header'
import WorkArea from './components/WorkArea/WorkArea'
import Toolbar from './components/WorkArea/Toolbar'
import Sidebar from './components/Sidebar/Sidebar'
import AuthStore from './store/authStore'
import SidebarStore from './store/sidebarStore'
import TemplateStore from './store/templateStore'
import PhotoStore from './store/photoStore'
import ElementStore from './store/elementStore'
import TextStore from './store/textStore'
import WorkAreaStore from './store/workAreaStore'
import HistoryStore from './store/historyStore'
import SaveStore from './store/saveStore'
import LayerStore from './store/layerStore'
import ViewStore from './store/viewStore'
import SharedView from './components/View/SharedView'
import ErrorStore from './store/errorStore'
import HiddenUpload from './components/Inputs/HiddenUpload'
import UpgradeModal from './components/Inputs/UpgradeModal'
import PricingModal from './components/Inputs/PricingModal'
import MockupStore from './store/mockupStore'
import MockupSidebar from './components/Mockup/MockupSidebar'
import IllustrationStore from './store/illustrationStore'
import errorStore from './store/errorStore'

const workareaStore = new WorkAreaStore(ErrorStore)
const mockupStore = new MockupStore(workareaStore, ErrorStore)
const layerStore = new LayerStore(workareaStore)
const templateStore = new TemplateStore(workareaStore, ErrorStore)
const illustrationStore = new IllustrationStore(errorStore, workareaStore)
const authStore = new AuthStore(workareaStore, null, ErrorStore)
const sidebarStore = new SidebarStore(workareaStore)
const photoStore = new PhotoStore(ErrorStore, workareaStore, authStore)
const elements = new ElementStore(ErrorStore)
const saveStore = new SaveStore(workareaStore, authStore)
authStore.saveStore = saveStore
mockupStore.saveStore = saveStore

function App () {
  const location = window.location.href
  const isView = location.includes('/view')

  const setScroll = e => {
    workareaStore.setContainerScroll(e.target.scrollLeft)
  }
   
  return (
    <Provider
      store={authStore}
      saveStore={saveStore}
      viewStore={ViewStore}
      historyStore={HistoryStore}
      mockupStore={mockupStore}
      templateStore={templateStore}
      errorStore={ErrorStore}
      workAreaStore={workareaStore}
      sidebarStore={sidebarStore}
      layerStore={layerStore}
      photoStore={photoStore}
      illustrationStore={illustrationStore}
      elementStore={elements}
      textStore={TextStore}
    >
      {isView ? 
      <>
        <Header isView={true} />
        <SharedView />
      </>
      :
      (
        <>
          <Header />
          <div onScroll={e => setScroll(e)} className='container-fluid d-flex' style={{ padding: '0', overflowX: 'scroll', overflowY: 'hidden', height: '100%' }}>
            <Sidebar />
            <Toolbar/>
            <div className='workarea-wrapper'>
              <WorkArea />
            </div>
            <MockupSidebar />
          </div>
        </>
      )}
      <HiddenUpload />
      <UpgradeModal />
      <PricingModal />
    </Provider>
  )
}

export default App
